import React from 'react';
import './loading.css';

export default ({ overlay }) => {
  let className = 'content-inner';
  if (overlay) {
    className += ' loading-overlay';
  }
  return (
    <div style={{ margin: 'auto', textAlign: 'center' }}>
      <div className="lds-default">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};
